// extracted by mini-css-extract-plugin
module.exports = {"container":"_1Y6VTjUeeH6ol5yygWi4Qu","heading":"BV09lS9z32vsMF5x8MkJ-","requiredLabel":"_371ioPF0honyo2_EqVKK3y","items":"_39vfK5dj6AXpD8Ik2uxPl-"};